import promise from 'redux-promise';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
const composeEnhancers = composeWithDevTools({
  realtime: true,
  name: 'Tolou Front Redux Devtools',
  hostname: 'localhost',
  port: 3000, // the port your remotedev server is running at
});

function saveToLocalStorage(state) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (e) {
    console.error(e);
  }
}
function loadFromLocalStorage() {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch (e) {
    console.error(e);
    return undefined;
  }
}
const persistedStore = loadFromLocalStorage();

// const persistedReducer = persistReducer(persistConfig, rootReducer);
let middleware;
if (process && process.env && process.env.NODE_ENV === 'production') {
  middleware = composeEnhancers(applyMiddleware(thunk, promise));
} else {
  middleware = composeEnhancers(applyMiddleware(thunk, promise));
}

let store = createStore(rootReducer, persistedStore, middleware);
store.subscribe(() =>
  saveToLocalStorage({
    language: store.getState().language,
    user: store.getState().user,
    requestToken: store.getState().requestToken,
  }),
);

export default store;
